var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetrolPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 752,
    height: 752,
    viewBox: "0 0 752 752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m525.65 204.57c-5.6836-5.6836-14.207-5.6836-19.891 0-5.6836 5.6836-5.6836 14.207 0 19.891l20.836 20.836c-2.8398 6.6289-4.7344 13.262-4.7344 20.836 0 23.68 16.102 43.57 37.887 50.199v182.8c0 10.418-8.5234 18.941-18.941 18.941-10.418 0-18.941-8.5234-18.941-18.941v-13.262c0-30.309-24.625-54.934-54.934-54.934l-0.003906-218.8c0-34.098-27.469-61.566-61.566-61.566l-146.81 0.003906c-34.098 0-61.566 27.465-61.566 61.562v356.13c-17.996 0-33.152 14.207-33.152 33.152h339.08c0-17.996-14.207-33.152-33.152-33.152h-4.7344l0.003906-107.98c14.207 0 26.52 11.367 26.52 26.52v12.316c0 26.52 21.785 47.359 47.359 47.359 26.52 0 47.359-21.785 47.359-47.359l-0.003907-226.37c1.8945-10.418-3.7852-9.4727-60.617-68.195zm-281.3 7.5742c0-8.5234 6.6289-14.207 15.156-14.207h144.91c7.5781 0 14.207 6.6289 14.207 14.207v111.77h-174.28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetrolPump);
export default __webpack_public_path__ + "static/media/petrol-pump.7a1d30c54b857a7c9b2ef020b544a3f1.svg";
export { ForwardRef as ReactComponent };